import { Box, FormControl, SelectChangeEvent, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomInputLabel, CustomMenuItem, CustomSelect, CustomSelectforCalendar, CustomSelectforPooja } from '../StyledComponents/StyledFields';
import styles from './CalenderHome.module.scss';
import constants from "../../../config/constants.json";
import CalenderData from './constructCalender';
import { CustomTooltip } from '../muhurtham/muhurtham';
import { CalenderBackendResponseProps, CalenderMajorEventsProps } from '../../../infrastructure/GlobalContextProvider';
import { apiRequest, authService, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import apiPath from '../../../config/apiPaths.json';
import ToastError from '../toast/toastError';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { isNil } from 'lodash';
import CommonDonationPopup from '../../home/CommonDonationPopup';
import ErrorPopup from '../ErrorPopup';

const CalenderHome = () => {
   const currentDate = new Date();
   const Months = [
      { id: 1, month: 'January' },
      { id: 2, month: 'February' },
      { id: 3, month: 'March' },
      { id: 4, month: 'April' },
      { id: 5, month: 'May' },
      { id: 6, month: 'June' },
      { id: 7, month: 'July' },
      { id: 8, month: 'August' },
      { id: 9, month: 'September' },
      { id: 10, month: 'October' },
      { id: 11, month: 'November' },
      { id: 12, month: 'December' },
   ];
   var currentMonthNumber = currentDate.getMonth();
   const [selectedYear, setSelectedYear] = useState<number>(currentDate.getFullYear());
   const [backendResponseList, setBackendResponseList] = useState<CalenderBackendResponseProps[]>([]);
   const [majorEventsList, setMajorEventsList] = useState<CalenderMajorEventsProps[]>([]);
   const [selectedMonthID, setSelectedMonthID] = useState<number>(currentMonthNumber + 1);
   const [currentThithi, setCurrentThithi] = useState<string>('');
   const [currentDayNakshatram, setcurrentDayNakshatram] = useState<string>('');
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const navigate = useNavigate();

   useEffect(() => {
      apiRequest({
         method: 'GET',
         endpoint: apiPath.calendarMonth,
         params: {
            year: selectedYear,
            month: selectedMonthID,
         },
      })
         .then((res) => {
            console.log(res.data);
            setBackendResponseList(res.data.calenderInfo);
            setMajorEventsList(res.data.majorEvents);
            setCurrentThithi(res.data.currentDayThithi);
            setcurrentDayNakshatram(res.data.currentDayNakshatram);
         })
         .catch((err) => {
            console.log(err);
            
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, [selectedYear, selectedMonthID]);


   const Years = [
      {
         year: 2021,
      },
      {
         year: 2022,
      },
      {
         year: 2023,
      },
      {
         year: 2024,
      },
      // {
      //    year: 2025,
      // },
   ];

   const handleYearChange = (event: SelectChangeEvent<unknown>) => {
      setSelectedYear(event.target.value as number);
   };

   // Function to handle the change of the selected month
   const handleMonthChange = (event: SelectChangeEvent<unknown>) => {
      setSelectedMonthID(event.target.value as number);
   };

   const YearsDropdown = (): React.ReactElement => {
      return (
         <FormControl className={styles.dropdown}>
            <CustomSelectforCalendar
               IconComponent={KeyboardArrowDownIcon}
               id="grouped-select"
               onChange={handleYearChange}
               value={selectedYear}
               MenuProps={{
                  PaperProps: {
                     sx: {
                        border: '1px solid #F05802',
                        '& ul': {
                           paddingTop: 0,
                           paddingBottom: 0,
                           overflowY: 'auto',
                           minHeight: 'auto',
                           maxHeight: '300px',
                           '&::-webkit-scrollbar': {
                              width: '8px',
                           },
                           '&::-webkit-scrollbar-thumb': {
                              background: '#F3C539',
                              borderRadius: '6px',
                           },
                        },
                     },
                  },
               }}
            >
               {Years.map((item, i) => (
                  <CustomMenuItem value={item.year} key={i}>
                     {item.year}
                  </CustomMenuItem>
               ))}
            </CustomSelectforCalendar>
         </FormControl>
      );
   };

   const MonthsDropdown = (): React.ReactElement => {
      return (
         <FormControl className={styles.dropdown}>
            <CustomSelectforCalendar
               IconComponent={KeyboardArrowDownIcon}
               id="grouped-select"
               onChange={handleMonthChange}
               value={selectedMonthID}
               MenuProps={{
                  PaperProps: {
                     sx: {
                        border: '1px solid #F05802',
                        '& ul': {
                           paddingTop: 0,
                           paddingBottom: 0,
                           overflowY: 'auto',
                           minHeight: 'auto',
                           maxHeight: '300px',
                           '&::-webkit-scrollbar': {
                              width: '8px',
                           },
                           '&::-webkit-scrollbar-thumb': {
                              background: '#F3C539',
                              borderRadius: '6px',
                           },
                        },
                     },
                  },
               }}
            >
               {Months.map((item, i) => (
                  <CustomMenuItem value={item.id} key={i}>
                     {item.month}
                  </CustomMenuItem>
               ))}
            </CustomSelectforCalendar>
         </FormControl>
      );
   };

 
  const handleDonate = () => {
    if (authService.isAuthenticated()) {
      navigate("/donations");
    } else {
      setIsOpen(true);
    }
  };

   const MajorEvents = () => {

      return (
         <Box className={styles.majorEventsContainer}>
            <Typography className={styles.title}>Major Events</Typography>
            <Box className={styles.majorEventCards} >
               {majorEventsList.map((item: CalenderMajorEventsProps, i: number) => {
                  const dateString = item.date; // Assuming item.date is a string like "2024-02-08"
                  const dateParts = dateString.split('-'); // Split the date string into parts
                  const day = dateParts[dateParts.length - 1];
                  return (
                     <Box key={i} className={styles.majorEventsSingleCard} onClick={handleDonate}>
                        <Box className={styles.singleCardDetails}>
                           <Box className={styles.datefeild}>
                              <Typography className={styles.date}>{day}</Typography>
                           </Box>
                           <Box className={styles.details}>
                              <CustomTooltip title={item.eventName} placement="top-start" arrow>
                                 <Typography className={styles.masam}>
                                    {item.eventName.length > 20
                                       ? `${item.eventName.slice(0, 20)}...`
                                       : item.eventName}
                                 </Typography>
                              </CustomTooltip>
                              {item.thithi && (
                                 <Typography className={styles.thithiAndNakshtra}>
                                    {item.thithi} {item.thithiTime}
                                 </Typography>
                              )}
                              {item.nakshtram && (
                                 <Typography className={styles.thithiAndNakshtra}>
                                    {item.nakshtram} {item.nakshtramTime}
                                 </Typography>
                              )}
                           </Box>
                        </Box>
                     </Box>
                  );
               })}
            </Box>
            <CommonDonationPopup isOpen={isOpen} setIsOpen={setIsOpen} />
         </Box>
      );
   };

   return (
      <Box className={styles.totalConatiner}>
         <Box className={styles.aboveContainer}>
            <Box className={styles.detailContainer}>
               <Typography className={styles.calenderName}>Calender</Typography>
               <Box className={styles.masamFeild}>
                  <img src="/images/moon.svg" className={styles.image} />
                  {currentThithi && (
                     <Typography className={styles.masamNames}>{currentThithi}</Typography>
                  )}
               </Box>
               <Box className={styles.masamFeild} sx={{ marginLeft: '15px' }}>
                  <img src="/images/star.svg" className={styles.image} style={{width: "55px", height: "55px"}}/>
                  {currentDayNakshatram && (
                     <Typography className={styles.masamNames}>{currentDayNakshatram}</Typography>
                  )}
               </Box>
            </Box>
            <Box className={styles.dropdownConatiner}>
               <Box>
                  <CustomInputLabel>Month</CustomInputLabel>
                  {MonthsDropdown()}
               </Box>
               <Box>
                  <CustomInputLabel>Year</CustomInputLabel>
                  {YearsDropdown()}
               </Box>
            </Box>
         </Box>
         <Typography className={styles.typoGraphy}>The times mentioned for Thithi and Nakshatra in the calendar should be interpreted as end times</Typography>
         <CalenderData
            year={selectedYear}
            month={Months.find((month) => month.id === selectedMonthID)?.month}
            backendResponseList={backendResponseList}
         />
         <Box className={styles.majorEventsContainer}>{MajorEvents()}</Box>
      </Box>
   );
};
export default CalenderHome;
